import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { LeagueService, LeaguePreview, League } from '../../services/league';

@Component({
  selector: 'app-join',
  imports: [CommonModule, RouterLink],
  templateUrl: './join.html',
  styleUrl: './join.css',
})
export class Join implements OnInit {
  preview = signal<LeaguePreview | null>(null);
  isLoading = signal(true);
  isJoining = signal(false);
  error = signal<string | null>(null);
  joinSuccess = signal(false);
  joinedLeague = signal<League | null>(null);

  hash: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private leagueService: LeagueService
  ) {}

  async ngOnInit(): Promise<void> {
    this.hash = this.route.snapshot.paramMap.get('hash');

    if (!this.hash) {
      this.error.set('Invalid league link');
      this.isLoading.set(false);
      return;
    }

    await this.loadPreview();
  }

  async loadPreview(): Promise<void> {
    if (!this.hash) return;

    this.isLoading.set(true);
    this.error.set(null);

    try {
      const data = await this.leagueService.getLeaguePreview(this.hash);
      this.preview.set(data);
    } catch (err) {
      if (err instanceof Error) {
        this.error.set(err.message);
      } else {
        this.error.set('Failed to load league');
      }
      console.error('Error loading league preview:', err);
    } finally {
      this.isLoading.set(false);
    }
  }

  async join(): Promise<void> {
    if (!this.hash || this.isJoining()) return;

    this.isJoining.set(true);
    this.error.set(null);

    try {
      const result = await this.leagueService.joinLeague(this.hash);
      this.joinedLeague.set(result.league);
      this.joinSuccess.set(true);
    } catch (err) {
      if (err instanceof Error) {
        this.error.set(err.message);
      } else {
        this.error.set('Failed to join league');
      }
      console.error('Error joining league:', err);
    } finally {
      this.isJoining.set(false);
    }
  }

  goToDashboard(): void {
    this.router.navigate(['/leagues']);
  }
}
